<!--
 * A Vue component for creating domains through a modal form.
 *
 * Dependencies
 * ==========
 * DomainDetail.vue component
 *
 * Properties
 * ==========
 * - launchModal -
 * Setting this property, triggers $_showDomainModal function.
 *
 * Events
 * ==========
 * - modal-domain-saved -
 * This event sends the created domain object to the subscriber.
 *
 * Usage
 * ==========
 * -In your parent component, create a boolean variable.
 * To launch the modal, set the value of the boolean variable.
 * The value of boolean variable needs to be changed in order to trigger the watch function.
 *
-->
<template>
    <div>
        <b-modal
            no-close-on-esc no-close-on-backdrop
            size="lg"
            hide-footer
            hide-header
            v-model="showModal"
        >
            <domain-detail
                :displayedInModal="true"
                @domain-cancel="$_hideModal"
                @generated-domain="$_onGeneratedDomain"
                @domain-saved="$_onSavedDomain"
                :tableResultSearchAttribute="tableResultSearchAttribute"
            >
            </domain-detail>
        </b-modal>
    </div>
</template>

<script>
    import DomainDetail from '../views/domains/DomainDetail.vue';
    export default {
        name: 'add-domain-modal',
        components: { 'domain-detail': DomainDetail },

        props: {
            launchModal: { type: Boolean, required: false, default: false },
            tableResultSearchAttribute: { type: Object, required: false, default: null }
        },

        data() {
            return { showModal: false };
        },

        methods: {
            $_showDomainModal() {
                this.showModal = true;
            },

            $_hideModal() {
                this.showModal = false;
            },

            $_onGeneratedDomain(data) {
                this.$emit('modal-generated-domain', data);
            },

            $_onSavedDomain(data) {
                this.$emit('modal-domain-saved', data);
                this.$_hideModal();
            }
        },

        watch: {
            launchModal(newValue, oldValue) {
                this.$_showDomainModal();
            }
        }
    };
</script>
